<template>
    <b-modal size="lg" v-model="show" class="fixedModalPotential" :hide-footer="true" title="Estudio de potencial Residencial" @hidden="hide">
        <div v-if="loading">
            <Loader :delay="0"></Loader>
        </div>
        <div v-else>
          <b-row>
            <b-col>
              <button v-if="!downloading" class="btn btn-secondary" @click="download">Descargar</button>
              <button v-else class="btn btn-secondary" disabled>
                <i style="padding-left:0em" class="fa fa-spinner fa-spin"></i>
              </button>
            </b-col>
          </b-row>
          <br>
          <b-tabs>
            <b-tab title="Resumen Residencial" active>
              <div class="scroll">
                <table class="table customtable">
                  <thead id="head">
                    <tr>
                      <th class="bordered" rowspan="2">CP</th>
                      <th class="bordered" rowspan="2">Área Lote</th>
                      <th class="bordered" colspan="3">Fincas Plurifamiliares</th>
                      <th class="bordered" colspan="3">Fincas Bifamiliares</th>
                      <th class="bordered" colspan="3">Fincas Unifamiliares</th>
                      <th class="bordered" colspan="5">PS Potencial</th>
                    </tr>
                    <tr>
                      <th>Con Activos</th>
                      <th>Sólo Captados</th>
                      <th class="bordered">Sin Activos</th>
                      <th>Con Activos</th>
                      <th>Sólo Captados</th>
                      <th class="bordered">Sin Activos</th>
                      <th>Con Activos</th>
                      <th>Sólo Captados</th>
                      <th class="bordered">Sin Activos</th>
                      <th style="width:5rem;">Mercado</th>
                      <th style="width:7rem;">Con Activos</th>
                      <th style="width:7rem;">Sólo Captados</th>
                      <th style="width:7rem;">Sin Activos</th>
                      <th style="width:5rem;">TOTALES</th>
                    </tr>
                  </thead>
                  <tbody id="body">
                    <tr v-for="(row, index) in residencialData" v-bind:key="index">
                      <td class="bordered">{{row['postal_code_address']}}</td>
                      <td class="bordered">{{row['lot_area_id']}}</td>
                      <td>{{row['fincas_plurifamiliares_activos']}}</td>
                      <td>{{row['fincas_plurifamiliares_captados']}}</td>
                      <td class="bordered">{{row['fincas_plurifamiliares_no_activos']}}</td>
                      <td>{{row['fincas_bifamiliares_activos']}}</td>
                      <td>{{row['fincas_bifamiliares_captados']}}</td>
                      <td class="bordered">{{row['fincas_bifamiliares_no_activos']}}</td>
                      <td>{{row['fincas_unifamiliares_activos']}}</td>
                      <td>{{row['fincas_unifamiliares_captados']}}</td>
                      <td class="bordered">{{row['fincas_unifamiliares_no_activos']}}</td>
                      <td colspan="5">
                        <table style="width:100%;">
                          <tr v-for="(mercado,i) in row['mercados']" :key="'mercado'+index+'_'+i">
                            <td style="width:5rem;">{{ mercado.market }}</td>
                            <td style="width:7rem;">{{ mercado.ps_activos }}</td>
                            <td style="width:7rem;">{{ mercado.ps_captados }}</td>
                            <td style="width:7rem;">{{ mercado.ps_sin_activos }}</td>
                            <td style="width:5rem;">{{ mercado.total }}</td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td class="bordered totals" colspan="2">{{residencialTotal['postal_code_address']}}</td>
                      <td class="totals">{{residencialTotal['fincas_plurifamiliares_activos']}}</td>
                      <td class="totals">{{residencialTotal['fincas_plurifamiliares_captados']}}</td>
                      <td class="bordered totals">{{residencialTotal['fincas_plurifamiliares_no_activos']}}</td>
                      <td class="totals">{{residencialTotal['fincas_bifamiliares_activos']}}</td>
                      <td class="totals">{{residencialTotal['fincas_bifamiliares_captados']}}</td>
                      <td class="bordered totals">{{residencialTotal['fincas_bifamiliares_no_activos']}}</td>
                      <td class="totals">{{residencialTotal['fincas_unifamiliares_activos']}}</td>
                      <td class="totals">{{residencialTotal['fincas_unifamiliares_captados']}}</td>
                      <td class="bordered totals">{{residencialTotal['fincas_unifamiliares_no_activos']}}</td>
                      <td style="width:5rem;">{{residencialTotal['market']}}</td>
                      <td class="totals" style="width:7rem;">{{residencialTotal['ps_activos']}}</td>
                      <td class="totals" style="width:7rem;">{{residencialTotal['ps_captados']}}</td>
                      <td class="totals" style="width:7rem;">{{residencialTotal['ps_sin_activos']}}</td>
                      <td class="totals" style="width:5rem;">{{residencialTotal['total']}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-tab>
            <b-tab title="Resumen Red">
              <div class="scroll">
                <table class="table customtable">
                  <thead id="head">
                    <tr>
                      <th rowspan="2">Rango Presión</th>
                      <th colspan="2">En Servicio (m)</th>
                      <th colspan="2">En Construcción (m)</th>
                      <th colspan="2">En Proyecto (m)</th>
                      <th rowspan="2">Totales</th>
                    </tr>
                    <tr>
                      <th>GN</th>
                      <th>GLP</th>
                      <th>GN</th>
                      <th>GLP</th>
                      <th>GN</th>
                      <th>GLP</th>
                    </tr>
                  </thead>
                  <tbody id="body">
                    <tr v-for="(row, index) in redData" v-bind:key="index">
                      <td>{{row['rango_presion']}}</td>
                      <td>{{row['en_servicio_gn'].toFixed(2)}}</td>
                      <td>{{row['en_servicio_glp'].toFixed(2)}}</td>
                      <td>{{row['en_construccion_gn'].toFixed(2)}}</td>
                      <td>{{row['en_construccion_glp'].toFixed(2)}}</td>
                      <td>{{row['en_proyecto_gn'].toFixed(2)}}</td>
                      <td>{{row['en_proyecto_glp'].toFixed(2)}}</td>
                      <td class="totals">{{row['total'].toFixed(2)}}</td>
                    </tr>
                    <tr>
                      <td class="totals">{{redTotal['rango_presion']}}</td>
                      <td class="totals">{{redTotal['en_servicio_gn'].toFixed(2)}}</td>
                      <td class="totals">{{redTotal['en_servicio_glp'].toFixed(2)}}</td>
                      <td class="totals">{{redTotal['en_construccion_gn'].toFixed(2)}}</td>
                      <td class="totals">{{redTotal['en_construccion_glp'].toFixed(2)}}</td>
                      <td class="totals">{{redTotal['en_proyecto_gn'].toFixed(2)}}</td>
                      <td class="totals">{{redTotal['en_proyecto_glp'].toFixed(2)}}</td>
                      <td class="totals">{{redTotal['total'].toFixed(2)}}</td>
                    </tr>
                  </tbody>
                </table>
                <br>
                <table class="table">
                  <thead>
                    <tr>
                      <th></th>
                      <th>En Servicio</th>
                      <th>En Construcción</th>
                      <th>En Proyecto</th>
                      <th>TOTALES</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Acometidas</td>
                      <td>{{acometidasData['EN SERVICIO']}}</td>
                      <td>{{acometidasData['EN CONSTRUCCION']}}</td>
                      <td>{{acometidasData['EN PROYECTO']}}</td>
                      <td class="totals">{{acometidasData['TOTALES']}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-tab>
          </b-tabs>
        </div>
    </b-modal>
</template>

<style scoped>
.bordered {
  border-right: 1px solid #7b7b7b !important;
}

th {
  text-align: center;
}
td {
  text-align: center;
  padding: 0 !important;
}

.fixedModalPotential .modal {
  bottom:initial;
  top: 2rem;
  min-height: 100%;
}

.totals {
  font-weight: bold;
  font-size: 15px;
}
</style>

<script>
import Loader from '@/components/Layout/Loader.vue';
import saveAs from 'file-saver';
const ReconnectingWebSocket = require('reconnecting-websocket');
import Vue from 'vue';

export default {
  name: 'PotentialResults',
  props: ['geom_geojson'],
  components: {Loader},
  data () {
    return {
      show: true,
      loading: false,
      residencialData: [],
      residencialDetails: [],
      redData: [],
      residencialTotal: {
        'postal_code_address': 'TOTALES',
        'lot_area_id': '',
        'fincas_plurifamiliares_activos': 0,
        'fincas_plurifamiliares_captados': 0,
        'fincas_plurifamiliares_no_activos': 0,
        'fincas_bifamiliares_activos': 0,
        'fincas_bifamiliares_captados': 0,
        'fincas_bifamiliares_no_activos': 0,
        'fincas_unifamiliares_activos': 0,
        'fincas_unifamiliares_captados': 0,
        'fincas_unifamiliares_no_activos': 0,
        'market': '',
        'ps_activos': 0,
        'ps_captados': 0,
        'ps_sin_activos': 0,
        'total': 0
      },
      redTotal: {
        'rango_presion': 'TOTALES',
        'en_servicio_gn': 0,
        'en_servicio_glp': 0,
        'en_construccion_gn': 0,
        'en_construccion_glp': 0,
        'en_proyecto_gn': 0,
        'en_proyecto_glp': 0,
        'total': 0
      },
      acometidasData: {
        'EN SERVICIO': 0,
        'EN CONSTRUCCION': 0,
        'EN PROYECTO': 0,
        'TOTALES': 0
      },
      socket: null,
      downloading: false
    };
  },
  methods: {
    download: function () {
      var message = {'type': 'excelresumenpotencial',
        'data': {
          'residencial': this.residencialData,
          'residencial_total': this.residencialTotal,
          'residencial_details': this.residencialDetails,
          'red': this.redData,
          'red_total': this.redTotal,
          'acometida': this.acometidasData
        }
      };
      this.downloading = true;
      this.socket.send(JSON.stringify(message));
    },
    hide: function () {
      this.$emit('hide');
    },
    groupBy: function (xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    parseResidencial: function (data, mercados) {
      this.residencialData = [...data];

      for (let i in this.residencialData) {
        var residencial = this.residencialData[i];

        let mercadostmp = mercados.filter(mercado => mercado.lot_area_id === residencial.lot_area_id); // get market by lot_area_id e.g. [{lot_area_id:123123, market:'SP}]

        residencial.mercados = mercadostmp.map(element => {
          let market = element['extendidaresidencial__market__cod_market'];
          let marketMinus = market.toLowerCase();
          return {'market': market,
            'ps_activos': residencial['ps_activos_' + marketMinus],
            'ps_captados': residencial['ps_captados_' + marketMinus],
            'ps_sin_activos': residencial['ps_sin_activos_' + marketMinus],
            'total': residencial['ps_activos_' + marketMinus] + residencial['ps_captados_' + marketMinus] + residencial['ps_sin_activos_' + marketMinus]
          };
        });

        this.residencialTotal.fincas_plurifamiliares_activos += residencial.fincas_plurifamiliares_activos;
        this.residencialTotal.fincas_plurifamiliares_captados += residencial.fincas_plurifamiliares_captados;
        this.residencialTotal.fincas_plurifamiliares_no_activos += residencial.fincas_plurifamiliares_no_activos;

        this.residencialTotal.fincas_bifamiliares_activos += residencial.fincas_bifamiliares_activos;
        this.residencialTotal.fincas_bifamiliares_captados += residencial.fincas_bifamiliares_captados;
        this.residencialTotal.fincas_bifamiliares_no_activos += residencial.fincas_bifamiliares_no_activos;

        this.residencialTotal.fincas_unifamiliares_activos += residencial.fincas_unifamiliares_activos;
        this.residencialTotal.fincas_unifamiliares_captados += residencial.fincas_unifamiliares_captados;
        this.residencialTotal.fincas_unifamiliares_no_activos += residencial.fincas_unifamiliares_no_activos;

        this.residencialTotal.ps_activos += residencial.ps_activos_sh + residencial.ps_activos_sv + residencial.ps_activos_sp;
        this.residencialTotal.ps_captados += residencial.ps_captados_sh + residencial.ps_captados_sv + residencial.ps_captados_sp;
        this.residencialTotal.ps_sin_activos += residencial.ps_sin_activos_sh + residencial.ps_sin_activos_sv + residencial.ps_sin_activos_sp;
      }
      this.residencialTotal.total = this.residencialTotal.ps_activos + this.residencialTotal.ps_captados + this.residencialTotal.ps_sin_activos;
    },
    parseRed: function (data) {
      var tmpRed = this.groupBy(data, 'presoper_rango_presion');

      var tipoRed = ['APB', 'APA', 'MPB', 'MPA', 'BP'];
      for (let index = 0; index < tipoRed.length; index++) {
        const list = tmpRed[tipoRed[index]];
        var element = {
          'rango_presion': tipoRed[index],
          'en_servicio_gn': 0,
          'en_servicio_glp': 0,
          'en_construccion_gn': 0,
          'en_construccion_glp': 0,
          'en_proyecto_gn': 0,
          'en_proyecto_glp': 0,
          'total': 0
        };

        if (list) {
          element.en_servicio_gn = list.filter(e => (e.amp_status_subtramo_red === 'EN SERVICIO' && e.amp_tipo_gas === 'GAS NATURAL')).map(el => el.longitud).reduce((a, c) => a + c, 0);
          element.en_servicio_glp = list.filter(e => (e.amp_status_subtramo_red === 'EN SERVICIO' && e.amp_tipo_gas === 'GAS PROPANO')).map(el => el.longitud).reduce((a, c) => a + c, 0);
          element.en_construccion_gn = list.filter(e => (e.amp_status_subtramo_red === 'EN CONSTRUCCION' && e.amp_tipo_gas === 'GAS NATURAL')).map(el => el.longitud).reduce((a, c) => a + c, 0);
          element.en_construccion_glp = list.filter(e => (e.amp_status_subtramo_red === 'EN CONSTRUCCION' && e.amp_tipo_gas === 'GAS PROPANO')).map(el => el.longitud).reduce((a, c) => a + c, 0);
          element.en_proyecto_gn = list.filter(e => (e.amp_status_subtramo_red === 'EN PROYECTO' && e.amp_tipo_gas === 'GAS NATURAL')).map(el => el.longitud).reduce((a, c) => a + c, 0);
          element.en_proyecto_glp = list.filter(e => (e.amp_status_subtramo_red === 'EN PROYECTO' && e.amp_tipo_gas === 'GAS PROPANO')).map(el => el.longitud).reduce((a, c) => a + c, 0);

          element.total = element.en_servicio_gn + element.en_servicio_glp + element.en_construccion_gn + element.en_construccion_glp + element.en_proyecto_gn + element.en_proyecto_glp;

          this.redTotal.en_servicio_gn = this.redTotal.en_servicio_gn + element.en_servicio_gn;
          this.redTotal.en_servicio_glp = this.redTotal.en_servicio_glp + element.en_servicio_glp;
          this.redTotal.en_construccion_gn = this.redTotal.en_construccion_gn + element.en_construccion_gn;
          this.redTotal.en_construccion_glp = this.redTotal.en_construccion_glp + element.en_construccion_glp;
          this.redTotal.en_proyecto_gn = this.redTotal.en_proyecto_gn + element.en_proyecto_gn;
          this.redTotal.en_proyecto_glp = this.redTotal.en_proyecto_glp + element.en_proyecto_glp;

          this.redTotal.total = this.redTotal.total + element.total;
        }
        this.redData.push(element);
      }
    },
    parseAcometidas: function (data) {
      var tmpAcometida = this.groupBy(data, 'amp_status_acometida');

      for (let index = 0; index < Object.keys(tmpAcometida).length; index++) {
        const list = tmpAcometida[Object.keys(tmpAcometida)[index]];
        this.acometidasData[Object.keys(tmpAcometida)[index]] = list.length;
        this.acometidasData['TOTALES'] = this.acometidasData['TOTALES'] + list.length;
      }
    },
    parseResult: function (data) {
      this.parseResidencial(data.residenciales, data.mercados);
      this.parseRed(data.red);
      this.parseAcometidas(data.acometidas);
      this.residencialDetails = [...data.residetails]; // IDs residenciales
    }
  },
  mounted: function () {
    var wsPath = Vue.http.options.ws_root;
    this.socket = new ReconnectingWebSocket(wsPath);

    var th = this;

    this.socket.onmessage = function (message) {
      var data = JSON.parse(message.data);
      if (data.action === 'completed') {
        saveAs(th.$http.options.root.split('api/')[0] + 'media/' + data.path, data.filename);
        th.downloading = false;
      } else if (data.action === 'error' || data.action === 'Error') {
        th.downloading = false;
        alert('Failed');
      } else if (data.action === 'Empty' || data.action === 'empty') {
        th.downloading = false;
        alert('Fichero vacío');
      }
    };

    this.loading = true;
    this.$http.post('estudio_potencial/', {geom_geojson: this.geom_geojson}).then(result => {
      if (result.data.error) {
        alert(result.data.error);
      } else { this.parseResult(result.data); }
      this.loading = false;
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/PotentialResults.vue